// Constants
export const datos_pacientes = () => {
  return {
    datos_pacientes: {
      id: {
        description: 'id autoincrement',
        label: 'Id',
        readonly: true,
        type: 'number',
        dataform: ['paciente_historial','paciente_agendar','paciente_agenda','paciente_pacientes','paciente_registrar','paciente_garantias'],
        datatype: {
          predeterminate: ''
        }
      },
      name: {
        type: 'text',
        label: 'Nombre',
        dataform: ['paciente_historial','paciente_agendar','paciente_agenda','paciente_pacientes','paciente_registrar','paciente_garantias'],
        placeholder: '',
        description: 'nombre completo',
        validate: 'required',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      }, 
      id_list_tipo:{
        type: 'number',
        label: 'Tipo',
        placeholder: '',
        description: 'Tipo de documento',
        validate: 'required',
        dataform: ['paciente_historial','paciente_agendar','paciente_agenda','paciente_pacientes','paciente_registrar','paciente_garantias'],
        datatype: { 
          disabled: false,
          type: 'select', 
          predeterminate: '1',
          list: 'list_tipo',
          label: 'name',
          agregar: true
        }
      },  
      id_list_genero: {
        type: 'text',
        label: 'Genero',
        dataform: ['paciente_historial','paciente_agendar','paciente_agenda','paciente_pacientes','paciente_registrar','paciente_garantias'],
        placeholder: '',
        description: 'Genero',
        validate: '',
        datatype: 
        {
          type: 'select', 
          disabled: false,
          predeterminate: '1',
          list: 'list_genero',
          label: 'name',
        }
      }, 
      id_list_eps: {
        type: 'number',
        label: 'Eps',
        dataform: ['paciente_historial','paciente_agendar','paciente_agenda','paciente_pacientes','paciente_registrar','paciente_garantias'],
        placeholder: '',
        description: 'Eps',
        validate: '',
        datatype: 
        {
          type: 'select', 
          disabled: false,
          predeterminate: '1',
          list: 'list_eps',
          label: 'name',
        }
      }, 
      documento: {
        type: 'number', 
        dataform: ['paciente_historial','paciente_agendar','paciente_agenda','paciente_pacientes','paciente_registrar','paciente_garantias'],
        label: 'Documento',
        placeholder: '',
        description: 'documento',
        validate: 'required|maxLength:15',
        datatype: 
        {
          type: 'price',
          disabled: false,
          predeterminate: 0,
          append: '',
          prepend: '',
        }
      },   
      edad: {
        type: 'number',
        label: 'Edad',
        placeholder: '',
        description: 'edad',
        prepend: '',
        dataform: ['paciente_historial','paciente_agendar','paciente_agenda','paciente_pacientes','paciente_registrar','paciente_garantias'],
        append: '',
        validate: 'required|maxLength:3',
        datatype: 
        {
          type: 'price',
          disabled: false,
          predeterminate: 0,
        }
      }, 
      direccion: {
        type: 'text',
        label: 'Direccion',
        dataform: ['paciente_historial','paciente_agendar','paciente_agenda','paciente_pacientes','paciente_registrar','paciente_garantias'],
        placeholder: '',
        description: 'Dirección y barrio',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',         
        }
      },  
      ciudad: {
        type: 'text',
        label: 'Ciudad',
        dataform: ['paciente_historial','paciente_agendar','paciente_agenda','paciente_pacientes','paciente_registrar','paciente_garantias'],
        placeholder: '',
        description: 'Dirección y barrio',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      }, 
      telefonos: {
        type: 'text',
        label: 'Teléfonos',
        dataform: ['paciente_historial','paciente_agendar','paciente_agenda','paciente_pacientes','paciente_registrar','paciente_garantias'],
        placeholder: '',
        description: 'No. de telefonos',
        validate: 'required',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      },
      email: {
        type: 'text',
        label: 'Email',
        dataform: ['paciente_historial','paciente_agendar','paciente_agenda','paciente_pacientes','paciente_registrar','paciente_garantias'],
        placeholder: '',
        description: 'correo electonico',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      },
      empresa: {
        type: 'text',
        label: 'Empresa',
        dataform: ['paciente_historial','paciente_agendar','paciente_agenda','paciente_pacientes','paciente_registrar','paciente_garantias'],
        placeholder: '',
        description: 'empresa en que labora',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      },
      cargo: {
        type: 'text',
        label: 'Profesión o cargo',
        dataform: ['paciente_historial','paciente_agendar','paciente_agenda','paciente_pacientes','paciente_registrar','paciente_garantias'],
        placeholder: '',
        description: 'Profesion y Cargo',
        validate: '',
        datatype: 
        {
          type: 'input',
          disabled: false,
          predeterminate: '',
        }
      },    
    }
  }
}

export function asign_datos_pacientes(){
  var asign= Object.keys(datos_pacientes().datos_pacientes);
  var objeto = datos_pacientes().datos_pacientes
  var nuevoArray = {}
  for(var i=0; i<asign.length; i++)
  {
          var createdataform= objeto[asign[i]].dataform
          for(var j=0; j<createdataform.length;  j++)
          {
                  nuevoArray[createdataform[j]] = {}
          }
  }        
  return nuevoArray
}

